export const CB_WALLET_APP_ID = '36b7972f-b87f-4c13-a313-1b00db0212ec';
export const CB_WALLET_TBA_APP_ID = '5178e0b1-06fe-4f07-99f4-f3aec024b70d';
export const CB_WALLET_VERSION_REGEX = /^cbwallet-cbpay-react-native@(\d+\.\d+\.\d+)$/;
export const SMART_CONTRACT_REDIRECT_URL = 'https://wallet.coinbase.com';
// This is not a real mobile version we just use it as a way to distinguish SCW
export const SMART_CONTRACT_VERSION = 'scw@1.0.0';
export const SMART_CONTRACT_WALLET_APP_ID = '1efee441-2f33-635d-9f21-128dac1fc074';
export const SMART_CONTRACT_WALLET_DEV_APP_ID = '558b75d2-f532-4b46-a752-43a382ea2b5f';
